import { default as AdvancesIcon } from "@/components/icons/advances";
import { default as AnnouncementIcon } from "@/components/icons/announcement";
import { default as AssetIcon } from "@/components/icons/asset";
import { default as AssetManagementIcon } from "@/components/icons/assetManagement";
import { default as AssignmentIcon } from "@/components/icons/assignment";
import { default as CalendarIcon } from "@/components/icons/calendar";
import { default as CommunicationFeedbackIcon } from "@/components/icons/communicationFeedback";
import { default as DashboardIcon } from "@/components/icons/dashboard";
import { default as DepartmentIcon } from "@/components/icons/building";
import { default as EmployeeManagementIcon } from "@/components/icons/employeeManagement";
import { default as EmployeesIcon } from "@/components/icons/employees";
import { default as ExpensesIcon } from "@/components/icons/expenses";
import { default as FinanceIcon } from "@/components/icons/finance";
import { default as FinancialTransactionsIcon } from "@/components/icons/financialTransactions";
import { default as Inventory } from "@/components/icons/inventory";
import { default as LeavesIcon } from "@/components/icons/leaves";
import { default as LocationIcon } from "@/components/icons/location";
import { default as LogsIcon } from "@/components/icons/logs";
import { default as BookIcon } from "@/components/icons/book";
import { default as OperationManagementIcon } from "@/components/icons/operationManagement";
import { default as OvertimeIcon } from "@/components/icons/overtime";
import { default as PayrollIcon } from "@/components/icons/payroll";
import { default as ProjectIcon } from "@/components/icons/projects";
import { default as ReportingIcon } from "@/components/icons/reporting";
import { default as ShiftIcon } from "@/components/icons/shift";
import { default as TimekeepingIcon } from "@/components/icons/timekeeping";
export type IconName =
  | "advances"
  | "announcement"
  | "asset"
  | "assetCategory"
  | "assetManagement"
  | "assignments"
  | "calendar"
  | "communicationFeedback"
  | "department"
  | "educationCatalog"
  | "educationManagement"
  | "examManagement"
  | "employeeManagement"
  | "employees"
  | "entrust"
  | "expenses"
  | "finance"
  | "financialTransactions"
  | "home"
  | "inventory"
  | "leaves"
  | "location"
  | "library"
  | "logs"
  | "operationManagement"
  | "overtime"
  | "payroll"
  | "projects"
  | "reporting"
  | "shift"
  | "staffTracking"
  | "timekeeping";

export const ICONS: Record<IconName, React.ComponentType<any>> = {
  advances: AdvancesIcon,
  announcement: AnnouncementIcon,
  asset: AssetIcon,
  assetCategory: AssetIcon,
  assetManagement: AssetManagementIcon,
  assignments: AssignmentIcon,
  calendar: CalendarIcon,
  communicationFeedback: CommunicationFeedbackIcon,
  department: DepartmentIcon,
  educationCatalog: AssignmentIcon,
  educationManagement: AssignmentIcon,
  examManagement: AssignmentIcon,
  employeeManagement: EmployeeManagementIcon,
  employees: EmployeesIcon,
  entrust: Inventory,
  expenses: ExpensesIcon,
  finance: FinanceIcon,
  financialTransactions: FinancialTransactionsIcon,
  home: DashboardIcon,
  inventory: Inventory,
  leaves: LeavesIcon,
  location: LocationIcon,
  library: BookIcon,
  logs: LogsIcon,
  operationManagement: OperationManagementIcon,
  overtime: OvertimeIcon,
  payroll: PayrollIcon,
  projects: ProjectIcon,
  reporting: ReportingIcon,
  shift: ShiftIcon,
  staffTracking: LogsIcon,
  timekeeping: TimekeepingIcon,
};
